class PrintService {
    public print(element: Element | string, hard: boolean = true) {
        let el: Element | null = null;

        if (typeof element === 'string') {
            el = document.getElementById(element);
        } else {
            el = element;
        }

        if (!el) {
            // eslint-disable-next-line
            console.error(`Element to print #${element} not found!`);
            return false;
        }

        if (hard) {
            const elToPrint = el.cloneNode(true) as HTMLElement;

            document.body.classList.add('print:hidden');

            document.documentElement.appendChild(elToPrint);

            window.print();

            document.documentElement.removeChild(elToPrint);

            document.body.classList.remove('print:hidden');
        } else {
            document.body.classList.add('print:invisible');

            el.classList.add('print:visible', 'print:absolute', 'print:inset-0');
            window.print();
            el.classList.remove('print:visible', 'print:absolute', 'print:inset-0');

            document.body.classList.remove('print:invisible');
        }

        return true;
    };
}

export default new PrintService();
